import { toast } from 'react-toastify'

export const toasterUtil = {
  info: (message: string): void => {
    toast(message, { type: 'info', toastId: message })
  },
  error: (message: string): void => {
    toast(message, { type: 'error', toastId: message })
  },
  warn: (message: string): void => {
    toast(message, { type: 'warning', toastId: message })
  },
  success: (message: string): void => {
    toast(message, { type: 'success', toastId: message })
  },
}
